(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-landing-craft-v2"] && !Shopify.designMode) return;
  try {
    
(function () {

  /* ─────────────────────────────────────────────
     AMBIENT BACKGROUND LOOP
     Scoped to this section via section.id.
     Uses DOMContentLoaded so getElementById is
     always called after the element exists.
  ───────────────────────────────────────────── */
  function setupAmbient() {
    var root    = document.getElementById('lp2-{{ section.id }}');
    if (!root) return;
    var hero    = root.querySelector('.lp2-hero');
    var bgVideo = root.querySelector('.lp2-hero__video--desktop') || root.querySelector('.lp2-hero__video');
    var reduce  = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mqDesk  = window.matchMedia('(min-width: 901px)');

    function startAmbient() {
      if (!bgVideo || !mqDesk.matches || reduce) return;
      hero.classList.add('has-bg-video');
      if (bgVideo.dataset.loaded !== '1') { bgVideo.load(); bgVideo.dataset.loaded = '1'; }
      var p = bgVideo.play();
      if (p && p.catch) p.catch(function () {});
    }

    // Stash references on the element so lightbox close can resume it
    root._lp2BgVideo      = bgVideo;
    root._lp2BgVideoMobile = root.querySelector('.lp2-hero__video--mobile');
    root._lp2MqDesk       = mqDesk;
    root._lp2StartAmbient = startAmbient;

    if (bgVideo) {
      if (mqDesk.matches && !reduce) startAmbient();
      if (mqDesk.addEventListener) {
        mqDesk.addEventListener('change', function (e) {
          if (e.matches) { startAmbient(); }
          else { try { bgVideo.pause(); } catch (err) {} hero.classList.remove('has-bg-video'); }
        });
      }
    }

    // GA4 / dataLayer scroll depth (needs root to exist)
    var depths = [25, 50, 75, 100], fired = {};
    window.addEventListener('scroll', function () {
      var pct = Math.round(((window.scrollY + window.innerHeight) / (root.offsetTop + root.offsetHeight)) * 100);
      depths.forEach(function (d) {
        if (pct >= d && !fired[d]) {
          fired[d] = true;
          var p = { event: 'scroll_depth', depth: d };
          if (window.dataLayer) window.dataLayer.push(p);
          if (typeof window.gtag === 'function') window.gtag('event', 'scroll_depth', p);
        }
      });
    }, { passive: true });

    // GA4 click events
    root.querySelectorAll('[data-lp-event]').forEach(function (el) {
      el.addEventListener('click', function () {
        var payload = { event: el.dataset.lpEvent };
        if (el.dataset.productName) payload.product_name = el.dataset.productName;
        if (window.dataLayer) window.dataLayer.push(payload);
        if (typeof window.gtag === 'function') window.gtag('event', el.dataset.lpEvent, payload);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAmbient);
  } else {
    setupAmbient();
  }

  /* ─────────────────────────────────────────────
     LIGHTBOX — event delegation on document.
     No getElementById, no timing dependency.
     Works regardless of when the script runs.
  ───────────────────────────────────────────── */
  function openLightbox(lp2Root) {
    if (!lp2Root) return;
    var lb    = lp2Root.querySelector('.lp2-lightbox');
    var stage = lb ? lb.querySelector('.lp2-lightbox__stage') : null;
    if (!lb || !stage) return;

    var mqDesk   = lp2Root._lp2MqDesk || window.matchMedia('(min-width: 901px)');
    var isMobile = !mqDesk.matches;
    var bgVideoDesktop = lp2Root._lp2BgVideo        || lp2Root.querySelector('.lp2-hero__video--desktop');
    var bgVideoMobile  = lp2Root._lp2BgVideoMobile  || lp2Root.querySelector('.lp2-hero__video--mobile');
    var bgVideo = (isMobile && bgVideoMobile) ? bgVideoMobile : (bgVideoDesktop || bgVideoMobile);
    var embedUrl = lp2Root.getAttribute('data-embed-url') || '';

    if (embedUrl) {
      stage.innerHTML = '<iframe src="' + embedUrl + '" title="Video" allow="autoplay; encrypted-media; fullscreen; picture-in-picture" allowfullscreen></iframe>';
    } else if (bgVideo) {
      // Build a fresh <video> from scratch — cloneNode of preload="none" is unreliable
      var v = document.createElement('video');
      v.controls = true; v.autoplay = true;
      v.setAttribute('playsinline', '');
      v.style.cssText = 'width:100%;height:100%;display:block;object-fit:contain;background:#000;';
      bgVideo.querySelectorAll('source').forEach(function (s) {
        var ns = document.createElement('source');
        ns.src = s.src; ns.type = s.type;
        v.appendChild(ns);
      });
      stage.innerHTML = '';
      stage.appendChild(v);
      v.load();
      var pp = v.play(); if (pp && pp.catch) pp.catch(function () {});
    }

    lb.classList.add('is-open');
    if (isMobile && bgVideo === bgVideoMobile && !embedUrl) {
      lb.classList.add('is-portrait');
    } else {
      lb.classList.remove('is-portrait');
    }
    lb.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (bgVideo) { try { bgVideo.pause(); } catch (e) {} }
  }

  function closeLightbox(lb) {
    if (!lb) return;
    var stage   = lb.querySelector('.lp2-lightbox__stage');
    var lp2Root = lb.closest('.lp2');
    lb.classList.remove('is-open', 'is-portrait');
    lb.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (stage) stage.innerHTML = '';
    if (lp2Root && lp2Root._lp2StartAmbient) lp2Root._lp2StartAmbient();
  }

  // Single delegated listener covers play, close, and backdrop clicks
  document.addEventListener('click', function (e) {
    var playBtn = e.target.closest('[data-lp-play]');
    if (playBtn) { e.preventDefault(); openLightbox(playBtn.closest('.lp2')); return; }

    var closeBtn = e.target.closest('.lp2-lightbox__close');
    if (closeBtn) { closeLightbox(closeBtn.closest('.lp2-lightbox')); return; }

    if (e.target.classList.contains('lp2-lightbox')) { closeLightbox(e.target); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var lb = document.querySelector('.lp2-lightbox.is-open');
      if (lb) closeLightbox(lb);
    }
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-landing-craft"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sectionEl = document.getElementById('lp-craft-{{ section.id }}');
  if (!sectionEl) return;

  // Animate elements below the fold only
  var animEls = sectionEl.querySelectorAll('.lp-animate');
  if ('IntersectionObserver' in window && animEls.length) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = parseInt(entry.target.dataset.animDelay) || 0;
          setTimeout(function () { entry.target.classList.add('lp-visible'); }, delay);
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    animEls.forEach(function (el, i) {
      el.dataset.animDelay = i * 120;
      obs.observe(el);
    });
  } else {
    animEls.forEach(function (el) { el.classList.add('lp-visible'); });
  }

  // GA4 / dataLayer event tracking
  sectionEl.querySelectorAll('[data-lp-event]').forEach(function (el) {
    el.addEventListener('click', function () {
      var payload = { event: el.dataset.lpEvent };
      if (el.dataset.productName) payload.product_name = el.dataset.productName;
      if (window.dataLayer) window.dataLayer.push(payload);
      if (typeof window.gtag === 'function') window.gtag('event', el.dataset.lpEvent, payload);
    });
  });

  // Scroll depth tracking
  var depths = [25, 50, 75, 100], fired = {};
  window.addEventListener('scroll', function () {
    var pct = Math.round(((window.scrollY + window.innerHeight) / (sectionEl.offsetTop + sectionEl.offsetHeight)) * 100);
    depths.forEach(function (d) {
      if (pct >= d && !fired[d]) {
        fired[d] = true;
        var p = { event: 'scroll_depth', depth: d };
        if (window.dataLayer) window.dataLayer.push(p);
        if (typeof window.gtag === 'function') window.gtag('event', 'scroll_depth', p);
      }
    });
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();
})();
